/* eslint-disable */
import * as Types from '../../../../../models/schema';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions =  {}
export type GetExceptionListVariablesDTO = Types.Exact<{
  search?: Types.Maybe<Types.Scalars['String']>;
  paging?: Types.Maybe<Types.PagingDTO>;
  sort?: Types.Maybe<Array<Types.Maybe<Types.SortDTO>> | Types.Maybe<Types.SortDTO>>;
}>;


export type GetExceptionListDTO = (
  { __typename?: 'Query' }
  & { exceptions: Array<(
    { __typename?: 'Exception' }
    & Pick<Types.ExceptionDTO, 'id'>
    & { name: Types.ExceptionDTO['text'] }
  )> }
);


export const GetExceptionListDocumentDTO = gql`
    query getExceptionList($search: String, $paging: Paging, $sort: [Sort]) {
  exceptions(filter: {text: {contains: $search}}, paging: $paging, sort: $sort) {
    id
    name: text
  }
}
    `;

/**
 * __useGetExceptionList__
 *
 * To run a query within a React component, call `useGetExceptionList` and pass it any options that fit your needs.
 * When your component renders, `useGetExceptionList` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetExceptionList({
 *   variables: {
 *      search: // value for 'search'
 *      paging: // value for 'paging'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useGetExceptionList(baseOptions?: Apollo.QueryHookOptions<GetExceptionListDTO, GetExceptionListVariablesDTO>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetExceptionListDTO, GetExceptionListVariablesDTO>(GetExceptionListDocumentDTO, options);
      }
export function useGetExceptionListLazyQueryDTO(baseOptions?: Apollo.LazyQueryHookOptions<GetExceptionListDTO, GetExceptionListVariablesDTO>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetExceptionListDTO, GetExceptionListVariablesDTO>(GetExceptionListDocumentDTO, options);
        }
export type GetExceptionListHookResult = ReturnType<typeof useGetExceptionList>;
export type GetExceptionListLazyQueryDTOHookResult = ReturnType<typeof useGetExceptionListLazyQueryDTO>;
export type GetExceptionListQueryResultDTO = Apollo.QueryResult<GetExceptionListDTO, GetExceptionListVariablesDTO>;